import {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowUpRightFromSquare, faAnglesDown, faAnglesUp} from "@fortawesome/free-solid-svg-icons";
import {VENUE_LIST} from "../config/venue";
import {Btn} from "./common/Btn";
import {DlBtn} from "./common/DlBtn";

export const VenueDetails = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleDetail = (id) => {
    setOpenItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <section id="venue">
      <div className="venueContainer">
        {VENUE_LIST.map((venue) => {
          const isFinished = new Date() >= new Date(venue.limitDate);
          const isOpen = !!openItems[venue.id];

          const venueDetail = (
            <div>
              <dl className="largeLetters">
                <dt>日時</dt>
                <dd>
                  {venue.dateText} {venue.timeText}
                </dd>
              </dl>
              <dl className="largeLetters">
                <dt>会場</dt>
                <dd>
                  {venue.venue}
                  <br />
                  <span>{venue.room}</span>
                </dd>
              </dl>
              <dl>
                <dt>アクセス</dt>
                <dd style={{whiteSpace: "pre-wrap"}}>{venue.access}</dd>
              </dl>
              <dl>
                <dt>定員</dt>
                <dd>{venue.capacity}</dd>
              </dl>
              <dl>
                <dt>参加費</dt>
                <dd>{venue.participationFee}</dd>
              </dl>
              <p>※同業他社の方のお申し込み・ご参加はご遠慮願います。</p>
            </div>
          );

          const appBtn = (
            // タイマー判定付きボタン
            <Btn
              targetDate={venue.limitDate}
              url={venue.url} // ← ここを追加！
              labelBefore={
                <>
                  お申し込みはこちら<span>{venue.limitDateDisplay}</span>
                  <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                </>
              }
            />
          );

          const mapWrap = <div className="mapWrap" dangerouslySetInnerHTML={{__html: venue.mapUrl}}></div>;

          return (
            <div key={venue.id} className="venueItem">
              <h3 id={venue.id}>
                <span className="districtLabel">{venue.district}開催</span>
                {isFinished && <span className="finishedLabel">終了しました</span>}
              </h3>

              {isFinished ? (
                <>
                  <DlBtn url={venue.dlUrl} district={venue.district} />

                  <p className="detailToggleBtn" onClick={() => toggleDetail(venue.id)} style={{cursor: "pointer"}}>
                    <strong>詳細</strong>を見る
                    <FontAwesomeIcon icon={isOpen ? faAnglesUp : faAnglesDown} />
                  </p>

                  <div className={`venueWrap isCollapsible ${isOpen ? "is-open" : "is-closed"}`}>
                    {venueDetail}
                    {appBtn}
                    {mapWrap}
                  </div>
                </>
              ) : (
                <div className="venueWrap">
                  {venueDetail}
                  {appBtn}
                  <DlBtn url={venue.dlUrl} district={venue.district} />
                  {mapWrap}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};
// import {Btn} from "./assets/Btn";

// export const VenueDetails = () => {
//   return (
//     <section id="">
//       <h3>大阪開催</h3>
//       <div>
//         <p className="dateAndTime">日時</p>
//         <p className="venue">会場</p>
//         <p className="access">アクセス</p>
//         <p className="capacity">定員</p>
//         <p className="participationFee">参加費</p>
//         <p>※同業他社の方のお申し込み・ご参加はご遠慮願います。</p>
//         <Btn targetDate="2027-01-29T15:23:20" labelBefore="予約受付中" labelAfter="受付終了" />
//       </div>
//     </section>
//   );
// };
